import axios from 'axios'
import rez from '../../../mixins/rezolutionWindow'
import router from '../../../router/index'

export default {
  namespaced: true,
  state() {
    return {
      showInfo: false,
      rightInfo: '',
      reloadUserRight: false
    }
  },
  getters: {
  },
  mutations: {
    SET_SHOW_INFO(state,data) {
      state.showInfo = data
    },
    SET_RIGHT_INFO(state,data) {
      state.rightInfo = data
    },
    SET_RELOAD_RIGHT(state,data) {
      state.reloadUserRight = data;
      setTimeout(() => {
        state.reloadUserRight = false
      }, 500)
    }
  },
  actions: {

  }
}
